import { useState, useMemo } from 'react';

export default function useSortFilterSearch(rows, searchFields) {
  const [sortConfig, setSortConfig] = useState({ col: null, dir: 'asc' });
  const [filters, setFilters]       = useState({});
  const [search, setSearch]         = useState('');

  function toggleSort(col) {
    setSortConfig(prev =>
      prev.col === col
        ? { col, dir: prev.dir === 'asc' ? 'desc' : 'asc' }
        : { col, dir: 'asc' }
    );
  }

  function setFilter(key, selected) {
    setFilters(prev => ({ ...prev, [key]: selected || [] }));
  }

  const processed = useMemo(() => {
    let result = [...rows];

    if (search.trim()) {
      const q = search.trim().toLowerCase();
      result = result.filter(r =>
        searchFields.some(fn => {
          const v = fn(r);
          return v && String(v).toLowerCase().includes(q);
        })
      );
    }

    Object.entries(filters).forEach(([key, selected]) => {
      if (!selected || selected.length === 0) return;
      const values = new Set(selected.map(o => o.value));
      result = result.filter(r => values.has(String(r[key] ?? '')));
    });

    if (sortConfig.col) {
      result.sort((a, b) => {
        const av = a[sortConfig.col] ?? '';
        const bv = b[sortConfig.col] ?? '';
        const cmp = String(av).localeCompare(String(bv), undefined, { numeric: true });
        return sortConfig.dir === 'asc' ? cmp : -cmp;
      });
    }

    return result;
  }, [rows, search, filters, sortConfig, searchFields]);

  return { processed, sortConfig, toggleSort, filters, setFilter, search, setSearch };
}
